module.exports = __webpack_public_path__ + "static/media/close.d2703adc.svg";